export default __webpack_public_path__ + "static/media/safari-desktop-2.722ae950.png";